/**
 * 要给用户分配某个按钮权限：
 * 需要在 v-permission 中写上当前权限标识。
 * 然后在菜单页面，添加按钮，然后写上相应的权限标识。(目前菜单由后端返回，前端暂没有页面添加)
 * 再在角色管理页面给相应用户分配这个权限。
 * 例如： <el-button v-permission="['userList_edit','roles_add']" > 新增 </el-button>
 */
import store from '@/store'
function checkPermission(el, binding) {
  const { value } = binding
  const roles = JSON.parse(store.state.user.buttonRoles)

  if (!Array.isArray(value) || value?.length === 0) {
    throw new Error(
      `Invalid roles! Expected an array with at least one role, e.g., v-permission="['userList_edit','roles_add']"`
    )
  }

  if (!value.some((permissionRole) => roles.includes(permissionRole))) {
    el.parentNode?.removeChild(el)
  }
}

export default {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  update(el, binding) {
    checkPermission(el, binding)
  }
}
